module.exports = __webpack_public_path__ + "img/Logos shayofae 512x512.d666a76a.png";